<template>
  <Card cardClasses="shadow-sm border-0">
    <!-- Header Section -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4 class="m-0 text-primary">
        <i class="bi bi-pencil me-2"></i>Edit Customer
      </h4>
      <div>
        <button class="btn btn-outline-secondary" @click="$router.go(-1)">
          <i class="bi bi-arrow-left me-1"></i> Back
        </button>
      </div>
    </div>

    <div class="container-fluid p-0">
      <div v-if="loading" class="text-center py-5">
        <Spinner spinner-class="mb-1" />
        <p class="text-muted mt-2">Loading customer...</p>
      </div>

      <div v-if="!loading" class="customer-form-content fade-in">
        <form @submit.prevent="submitForm">
          <!-- Customer Information -->
          <div class="card border-0 shadow-sm mb-4">
            <div class="card-header bg-light py-3">
              <h5 class="mb-0"><i class="bi bi-info-circle me-2"></i>Customer Information</h5>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="form-group col-md-6">
                  <label for="name" class="form-label fw-bold">Name:</label>
                  <input type="text" class="form-control" v-model="customer.name" required>
                </div>
                <div class="form-group col-md-6">
                  <label for="email" class="form-label fw-bold">Email:</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-envelope"></i></span>
                    <input type="email" class="form-control" v-model="customer.email">
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="phone" class="form-label fw-bold">Phone:</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-telephone"></i></span>
                    <input type="text" class="form-control" v-model="customer.phone" required>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="address" class="form-label fw-bold">Address:</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
                    <input type="text" class="form-control" v-model="customer.address">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-flex justify-content-center gap-3 mt-4 mb-3">
            <button class="btn btn-outline-secondary px-4" @click="$router.go(-1)">
              <i class="bi bi-arrow-left me-1"></i> Cancel
            </button>
            <button v-if="profile.role !== 'user'" type="submit" class="btn btn-primary px-4">
              <i class="bi bi-check-lg me-1"></i> Update Customer
            </button>
          </div>
        </form>
      </div>
    </div>
  </Card>
</template>

<script>
import customerService from "@/api/customerService";
import {decrypt} from "@/utils/crypto";
import loadingButton from "@/utils/loadingButton";

export default {
  name: "EditCustomer",
  data(){
    return {
      profile: {},
      loading: true,
      customer: {},
    }
  },
  methods:{
    async fetchCustomer(){
      try {
        this.customer = await customerService.getCustomer(this.$route.params.id);
      } catch(e){ console.error(e); } finally { this.loading = false; }
    },
    async submitForm(e){
      try {
        loadingButton(e);
        await customerService.updateCustomer(this.customer, this.$route.params.id);
      } catch(e){ console.error(e); } finally { loadingButton(e,false); }
    }
  },
  async created(){
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
    await this.fetchCustomer();
  }
}
</script>

<style scoped>
.customer-form-content{ padding:0.5rem; }
</style>
